<template>
  <v-card
    class="mx-auto"
  >
    <template v-for="(referencia, index) in referencias">
      <v-list-item three-line :key="referencia.empresa">
        <v-list-item-content>
          <v-list-item-title>{{ referencia.empresa }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ referencia.contato }} - {{ referencia.formattedTelefone }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ referencia.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="remove(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider :key="`div-${referencia.empresa}`"/>
    </template>
  </v-card>
</template>

<script>
export default {
  props: {
    referencias: Array,
  },
  methods: {
    remove(index) {
      this.$emit('remove', index);
    },
  },
};
</script>
